import {Directive, OnDestroy} from '@angular/core';
import {MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';

/**
 * Директива - фикс спадающего списка mat-autocomplete при скролле страницы.
 * Закрепляет список на своем месте.
 */
@Directive({
    selector: 'input[matAutocomplete]',
    standalone: true
})
export class AutocompletePositionDirective implements OnDestroy {

    public constructor(
        private readonly matAutocompleteTrigger: MatAutocompleteTrigger,
    ) {
        window.addEventListener('scroll', this.#scrollHandler, true);
    }

    public ngOnDestroy(): void {
        window.removeEventListener('scroll', this.#scrollHandler, true);
    }

    /** Обработчик события скролла страницы */
    #scrollHandler = (): void => {
        if (this.matAutocompleteTrigger == null) {
            return;
        }
        if (this.matAutocompleteTrigger.panelOpen) {
            this.matAutocompleteTrigger.updatePosition();
        }
    }
}
